import { Component } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { filteredContracts, getContract } from "@edp-store/selectors/contract.selectors";
import { environment } from "@edp-environments/environment";
import { EdpToasterService } from "@edp-components/edp-toaster/edp-toaster.service";
import { EdpToastType } from "@edp-components/edp-toaster/edp-toast-type";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { combineLatest } from "rxjs";
import { getShowNewLocalToastr } from "@edp-store/selectors/dashboard.selectors";
import { ShowNewLocalToastr } from "@edp-store/actions/dashboard.actions";
import { getUser } from "@edp-store/selectors/user.selectors";
import { SetViewToastLocalReception } from "@edp-store/actions/user.actions";
import { getContractEs } from "@edp-store/selectors/ES/contract-es.selectors";
import { IAppEsState } from "@edp-store/state/ES/app-es.state";

const keyRouteRedirectLocalStorage = "redirectToRoute";
@Component({
    selector: "dashboard-es",
    templateUrl: "./dashboard-es.component.html",
    styleUrls: ["./dashboard-es.component.scss"],
})
export class DashboardESComponent {
    public contract$ = this.storeES.pipe(select(getContractEs));
    public newLocalToastr$ = this.store.pipe(select(getShowNewLocalToastr));
    // public filteredContracts$ = this.store.pipe(select(filteredContracts));
    public user$ = this.store.pipe(select(getUser));
    public isApp: boolean;
    private isShown = false;

    constructor(
        public store: Store<IAppState>,
        public storeES: Store<IAppEsState>,
        private toasterService: EdpToasterService,
        private translateService: TranslateService,
        private router: Router
    ) {
        this.isApp = environment.isApp;

        // combineLatest([this.contract$, this.newLocalToastr$, this.user$, this.filteredContracts$]).subscribe(
        //     ([contract, showToastr, user, contracts]) => {
        //         if (!!contract && !!showToastr && !!user) {
        //             this.showNewLocalToastr(contract.ContractId, user.loginNr);
        //         }
        //         if (!!this.hasRouteToRedirect() && contract && contracts?.filtered?.length === 1) {
        //             this.routeToRedirect();
        //         }
        //     }
        // );
    }

    private hasRouteToRedirect() {
        return !!localStorage.getItem(keyRouteRedirectLocalStorage);
    }

    private routeToRedirect() {
        const routeToRedirect = localStorage.getItem(keyRouteRedirectLocalStorage);
        localStorage.removeItem(keyRouteRedirectLocalStorage);
        this.router.navigate([routeToRedirect], { queryParamsHandling: "merge" });
    }

    private showNewLocalToastr(contractId, loginNr) {
        this.store.dispatch(new ShowNewLocalToastr(false));
        this.toasterService
            .create(this.translateService.instant("pt.edp.edponline.new.local.toaster.description"), EdpToastType.info, {
                showLeftIcon: false,
                showCloseModalButton: true,
                textButton: this.translateService.instant("pt.edp.edponline.new.local.toaster.button"),
            })
            .show()
            .then(response => {
                this.router.navigate([`/locais-consumo/${contractId}/inicio`]);
                this.store.dispatch(new SetViewToastLocalReception((loginNr += 1)));
            });
    }
}
